import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { navigate } from 'gatsby';

import theme from '@klaviyo-mkt/gatsby-components/shared/styles/themes/default';
import ComponentLoop from '@klaviyo-mkt/gatsby-theme-marketing/src/components/component-loop';
import { Breadcrumbs } from '@klaviyo-mkt/gatsby-components/molecules/breadcrumbs';
import { useShouldDisplayBreadcrumbs } from '@klaviyo-mkt/gatsby-theme-marketing/src/hooks/useBreadcrumbs';
import Layout from '@klaviyo-mkt/gatsby-theme-marketing/src/templates/layout';

import * as styles from './styles/blogPage.module.scss';

import type { PageProps } from 'gatsby';
import type { IComponentLayout } from '@klaviyo-mkt/gatsby-theme-marketing/src/components/component-loop';
import type { IPageBase } from '@klaviyo-mkt/gatsby-theme-marketing/src/templates/page/types';


export interface IBlogHomeData extends IPageBase {
  defaultPage: IPageBase & {
    components: IComponentLayout[];
  };
}

const themeOverrides = {
  ...theme,
  global: {
    ...theme.global,
    light: {
      ...theme.global.light,
      backgroundColor: theme.colors.white,
    },
  },
};


const BlogHome = ({ data, ...pageProps }: PageProps<IBlogHomeData>) => {

  const { t, i18n } = useTranslation();
  const { shouldShowBreadcrumbs, homePrefix } = useShouldDisplayBreadcrumbs('/blog', 'default', true, i18n.language);

  useEffect(() => {
    if (data?.defaultPage === null) {
      navigate('/404');
    }
  }, []);

  if (data?.defaultPage === null) {
    return null;
  }
  return (
    <Layout
      {...pageProps}
      heroBackground="lightSand"
      showBreadcrumbs={false}
      templateName="Default"
      theme={themeOverrides}
      translations={data?.defaultPage?.translations}
    >
      
      <div className={styles.blogHomeContent}>
        { shouldShowBreadcrumbs && <div className={styles.blogBreadcrumbs}><Breadcrumbs breadcrumbs={[{ link: homePrefix, text: t('breadcrumbs_home') }, { text: t('breadcrumbs_blog') }]} /></div> }
        <ComponentLoop components={data?.defaultPage?.components} />
      </div>
    </Layout>
  );
};

export default BlogHome;
